export enum Platform {
  BOOKING_WEB = 'BOOKING_WEB',
  BOOKING_DASHBOARD = 'BOOKING_DASHBOARD',
  CLINIC_DASHBOARD = 'CLINIC_DASHBOARD',
}
